// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function FileStar(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "FileStar" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 21V3H14L19 7V21H5ZM13.1803 11.6287L12 8L10.8197 11.6287H7L10.0902 13.8713L8.90983 17.5L12 15.2574L15.0902 17.5L13.9098 13.8713L17 11.6287H13.1803Z", fill: "currentColor" }))));
});
//# sourceMappingURL=FileStar.js.map